import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  CustomInput,
} from "reactstrap";
import {
  AvForm,
  AvGroup,
  AvField,
  AvCheckboxGroup,
} from "availity-reactstrap-validation";

import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";

const dataService = require("../../services/dataServices.js");

const AddTeamMember = () => {
  const navigate = useHistory();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [active, setActive] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  async function constructObject() {
    var obj = {
      first_name: firstName,
      last_name: lastName,
      active_flag: active ? 1 : 0,
    };

    return obj;
  }

  async function save() {
    setIsLoading(true);
    var obj = await constructObject();
    var result = await dataService.addTeamMember(obj);

    showToastr(result.result.team_member_id);
  }

  function performCancel() {
    navigate.goBack();
  }

  function showToastr(team_member_id) {
    const options = {
      timeOut: 3000,
      showCloseButton: true,
      progressBar: false,
      position: "top-center",
      onHideComplete: () => {
        navigate.push("/analytics/commentingteam/edit/" + team_member_id);
        setIsLoading(false);
      },
    };
    const toastrInstance = toastr.success;
    toastrInstance(
      "Add Team Member",
      "Your changes have been saved successfully.",
      options
    );
  }

  return (
    <Container fluid>
      <Header>
        <HeaderTitle>Add Team Member</HeaderTitle>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/dashboard">Dashboard</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/analytics/commentingteam">Commenting Team</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Add Team Member</BreadcrumbItem>
        </Breadcrumb>
      </Header>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <AvForm onValidSubmit={save}>
                <Row>
                  <Col sm={6}>
                    <AvGroup>
                      <Label for="first_name">First Name</Label>
                      <AvField
                        bsSize="lg"
                        type="text"
                        name="first_name"
                        id="first_name"
                        placeholder="Enter first name"
                        value={firstName}
                        disabled={isLoading}
                        onChange={(e) => setFirstName(e.target.value)}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Please enter a first name.",
                          },
                        }}
                      />
                    </AvGroup>
                  </Col>
                  <Col sm={6}>
                    <AvGroup>
                      <Label for="last_name">Last Name</Label>
                      <AvField
                        bsSize="lg"
                        type="text"
                        name="last_name"
                        id="last_name"
                        placeholder="Enter last name"
                        value={lastName}
                        disabled={isLoading}
                        onChange={(e) => setLastName(e.target.value)}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Please enter a last name.",
                          },
                        }}
                      />
                    </AvGroup>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={4}>
                    <Label for="active">Active?</Label>
                    <AvCheckboxGroup name={"active"}>
                      <CustomInput
                        type="checkbox"
                        id={"active"}
                        label="Active"
                        checked={active}
                        disabled={isLoading}
                        onChange={(e) => setActive(e.target.checked)}
                      />
                    </AvCheckboxGroup>
                  </Col>
                </Row>
                <div className="mt-3">
                  <Button
                    color="light"
                    size="lg"
                    className="mr-2"
                    onClick={performCancel}
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" size="lg" disabled={isLoading}>
                    {isLoading && (
                      <Spinner size="sm" className="mr-2 align-middle" />
                    )}
                    Save
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddTeamMember;
